'use strict';

var _setup = require('./setup.js');

var templateType = _setup.s.$body.data('shopify-template');

var $embed = $('<div id="nx-vidplayer-embed"></div>');
var $embedOuter = _setup.s.$videoOverlay.find('.nx-vidplayer--outer');

var plyr = null;
var embedded = false;

var isVideo = {
	btn: _setup.s.$videoPlayBtns.length > 0,
	poster: _setup.s.$videoposters.length > 0
};

// Close The Video Modal ---------------------------------- //
var closePlayerModal = function closePlayerModal() {
	plyr[0].stop();
	plyr[0].destroy();
	plyr = null;

	_setup.s.$body.removeClass('is-video-playing');
	_setup.s.$doc.trigger('nx.video.close');
	TweenMax.to(_setup.s.$videoOverlay, 0.2, { autoAlpha: 0, onComplete: function onComplete() {
			return _setup.s.$body.removeClass('is-showing-overlay');
		} });
};

// Open A Video Modal ---------------------------------- //
var openPlayerModal = function openPlayerModal(type, id, e) {
	e.preventDefault();
	if (!type || !id) {
		console.warn('A data attribute is missing, include video-type & video-id on modal buttons');
		return false;
	}
	currentlyPlayingId = id;

	_setup.s.$body.addClass('is-showing-overlay is-opening-overlay');
	_setup.s.$doc.trigger('nx.video.open');

	if (embedded) {
		$embed = _setup.s.$videoOverlay.find('#nx-vidplayer-embed');
	} else {
		_setup.s.$videoEmbedTarget.prepend($embed);
		embedded = true;
	}
	$embed.attr({ 'data-type': type, 'data-video-id': id });

	var plyropts = {
		tooltips: { controls: false, seek: true },
		clickToPlay: false,
		hideControls: true,
		controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'fullscreen'],
		autoplay: window.Modernizr && window.Modernizr.videoautoplay ? true : false
	};
	plyr = window.plyr.setup($embed[0], plyropts);

	plyr[0].on('ready', function () {
		//plyr[0].play();
		TweenMax.to($embedOuter, 0.75, { autoAlpha: 1, y: 0, scale: 1, delay: 0.25, ease: Expo.easeOut,
			onComplete: function onComplete() {
				return _setup.s.$body.removeClass('is-opening-overlay').addClass('is-video-playing');
			} });
	});

	plyr[0].on('ended', function () {
		closePlayerModal();
		if (needsPlaylist) {
			setTimeout(function () {
				return playNextVideo(currentlyPlayingId);
			}, 350);
		}
	});

	_setup.s.$videoOverlay.css({ minHeight: $embedOuter.height() + 'px' });

	TweenMax.set($embedOuter, { autoAlpha: 0, scale: 1.5 });
	TweenMax.to(_setup.s.$videoOverlay, 0.3, { autoAlpha: 1 });
};

// Autoplay Enhancement for Landing Pages -------------------- //
var videoList = null;
var videoTypesList = [];
var currentlyPlayingId = null;
var needsPlaylist = templateType === 'page.jaguars';

var $autoplayPrev = $('<button id="nx-autoplay-prev" class="btn-reset"><span>Prev</span></button>');
var $autoplayNext = $('<button id="nx-autoplay-next" class="btn-reset"><span>Next</span></button>');

var getPlaylist = function getPlaylist() {
	var $allbtns = $('.nx-bloglist--imglink[data-video-id], .nx-playbtn--btn[data-video-id], nx-recipestep--videotrigger[data-video-id]');
	var result = [];
	$allbtns.each(function (i, item) {
		result.push($(item).data('video-id'));
		videoTypesList.push($(item).data('video-type'));
	});
	return result;
};
var playNextVideo = function playNextVideo(id) {
	var idpos = videoList.indexOf(id);
	var nextid = videoList[idpos + 1];
	var nexttype = videoTypesList[idpos + 1];
	if (idpos === videoList.length - 1) {
		nextid = videoList[0];
		nexttype = videoTypesList[0];
	}
	openPlayerModal(nexttype, nextid, { preventDefault: $.noop });
};
var playPrevVideo = function playPrevVideo(id) {
	var idpos = videoList.indexOf(id);
	var previd = videoList[idpos - 1];
	var prevtype = videoTypesList[idpos - 1];
	if (idpos === 0) {
		previd = videoList[videoList.length - 1];
		prevtype = videoTypesList[videoList.length - 1];
	}
	openPlayerModal(prevtype, previd, { preventDefault: $.noop });
};
var enhancedPlaylist = function enhancedPlaylist() {
	videoList = getPlaylist();
	_setup.s.$videoOverlay.find('.nx--site-contain').prepend($autoplayPrev, $autoplayNext);

	$autoplayPrev.on('click', function () {
		return playPrevVideo(currentlyPlayingId);
	});
	$autoplayNext.on('click', function () {
		return playNextVideo(currentlyPlayingId);
	});
};

// Force Video To Stay Within Viewport ----------------------------//
var videoLayoutHandlers = function videoLayoutHandlers() {
	var interval = null;
	var vidHeight = null;
	var startwidth = 100;

	var checkViewport = function checkViewport() {
		vidHeight = $embedOuter.outerHeight();
	};
	_setup.s.$doc.on('nx.video.open', function () {
		interval = window.setInterval(checkViewport, 250);
	});
	_setup.s.$doc.on('nx.video.close', function () {
		return window.clearInterval(interval);
	});
};

// Start everything if we're on a page with video buttons -----------//
if (isVideo.btn) {
	_setup.s.$videoPlayBtns.each(function (index, item) {
		var $this = $(item);
		var $parent = $this.parent('.nx-playbtn');
		if ($parent.length) {
			$this.hover(function () {
				return $parent.addClass('is-hovering');
			}, function () {
				return $parent.removeClass('is-hovering');
			});
		}
		$this.click(function (event) {
			return openPlayerModal($this.data('video-type'), $this.data('video-id'), event);
		});
	});
	_setup.s.$videoClose.click(function () {
		return closePlayerModal();
	});
}
if (isVideo.poster) {
	_setup.s.$videoposters.each(function (i, item) {
		var $this = $(item);
		$this.find('.nx--lazyload').on('nx.imgloaded', function () {
			return $this.addClass('is-imgloaded');
		});
	});
}
if (isVideo.poster || isVideo.btn) {
	enhancedPlaylist();
}


//////////////////
// WEBPACK FOOTER
// ./_js/video-players.js
// module id = 16
// module chunks = 0